import { DateHelper } from "@swivl-mono/helpers";
import { ReviewInterface, ReviewPlatform } from "@swivl-mono/types";

import { ReviewView } from "../Review/Review.View";

export interface ReviewsManagerViewFilters {
  responded: boolean;
  notResponded: boolean;
  deletedOnGoogle: boolean;
  starRating1: boolean;
  starRating2: boolean;
  starRating3: boolean;
  starRating4: boolean;
  starRating5: boolean;

  google: boolean;
  yelp: boolean;
  spot: boolean;

  stores: { [key: number]: boolean };
}
export interface ReviewsManagerViewFilterCounts {
  responded: number;
  notResponded: number;
  deletedOnGoogle: number;
  starRating1: number;
  starRating2: number;
  starRating3: number;
  starRating4: number;
  starRating5: number;

  google: number;
  yelp: number;
  spot: number;

  stores: { [id: number]: number };

  total: number;
  filtered: number;
  selected: number;
  selectableRows: { [id: number]: ReviewInterface };
}
export const blankReviewCounts: ReviewsManagerViewFilterCounts = {
  responded: 0,
  notResponded: 0,
  deletedOnGoogle: 0,
  starRating1: 0,
  starRating2: 0,
  starRating3: 0,
  starRating4: 0,
  starRating5: 0,

  google: 0,
  yelp: 0,
  spot: 0,

  stores: {},

  total: 0,
  filtered: 0,
  selected: 0,
  selectableRows: {}
};

/** Single source of truth for "was this review deleted on Google" - used by the banner, the per-row checkbox, and Select-All. */
export function isReviewDeletedOnGoogle(review: ReviewInterface): boolean {
  return review.platform === ReviewPlatform.GOOGLE && !!review.deletedDate;
}

export function getReviewsViewData(reviews: ReviewInterface[], selectedReviews: { [id: number]: ReviewInterface }, showMultiSelect: boolean) {
  if (!reviews || reviews.length === 0) {
    return [];
  }

  return reviews
    .sort((a, b) => DateHelper.normalize(b.reviewDate).getTime() - DateHelper.normalize(a.reviewDate).getTime())
    .map((review: ReviewInterface) => {
      const selected = selectedReviews[review.id] !== undefined;
      return <ReviewView key={review.id} review={review} selected={selected} showingMultiSelect={showMultiSelect} />;
    });
}
